export default (route) => {
    const routeParams = route.params?.type;

    if ('register' === route.name && 'pro' === routeParams) {
        return true;
    }
};
